import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync } from '../../core/ComponentSync.js';
import { TS_Overlay } from '../TS_Overlay/index.js';
import { stopPropagation } from '../../utils/tools.js';
import { ModuleFE_Dialog } from '../../component-modules/ModuleFE_Dialog.js';
import './TS_DialogOverlay.scss';
import { removeFromArray, resolveContent } from '@nu-art/ts-common';
export class TS_DialogOverlay extends ComponentSync {
    deriveStateFromProps(nextProps) {
        return { models: [] };
    }
    __showDialog = (model) => {
        this.state.models.push(model);
        this.forceUpdate();
    };
    __closeDialog = (dialogModel) => {
        const dialogKey = dialogModel?.dialogKey;
        if (!dialogKey)
            this.state.models.pop();
        else
            removeFromArray(this.state.models, model => model.dialogKey === dialogKey);
        this.forceUpdate();
    };
    render() {
        if (!this.state.models.length)
            return '';
        const lastModel = this.state.models[this.state.models.length - 1];
        return (_jsx("div", { className: "ts-dialog__overlay", children: _jsx(TS_Overlay, { showOverlay: true, onClickOverlay: this.onOverlayClicked, className: lastModel.overlayClass, children: this.state.models.map((model, i) => {
                    const content = resolveContent(model.content, () => this.forceUpdate());
                    if (i === this.state.models.length - 1)
                        //This model content is wrapped in a div to keep the React hierarchy. if you remove it, the model stack won't work.
                        return _jsx("div", { onClick: stopPropagation, onContextMenu: stopPropagation, children: content }, i);
                    return _jsx("div", { style: { display: 'none', height: 0 }, children: content }, i);
                }) }) }));
    }
    onOverlayClicked = (e) => {
        stopPropagation(e);
        //Exit if click should not close this current dialog
        if (!this.state.models[0].closeOverlayOnClick())
            return;
        //Close there is only one dialog
        if (this.state.models.length === 1)
            return ModuleFE_Dialog.close(false, this.state.models[0].dialogKey);
        //Close only this dialog if more than one
        this.state.models.pop();
        this.forceUpdate();
    };
}
//# sourceMappingURL=TS_DialogOverlay.js.map